module.exports = __webpack_public_path__ + "static/media/we_are_dicks.5706e668.mp3";